<template>
  <div v-if="lock" class="seat-lock" role="dialog" aria-modal="true" :aria-label="$t('linking.seatLockedTitle')">
    <div class="seat-lock__card">
      <!-- The device that holds the account (DeviceIconView, 96 × 96). -->
      <span class="seat-lock__device" aria-hidden="true">
        <SfIcon :name="holderIcon" :size="53" :stroke-width="1.75" />
      </span>
      <h2 class="seat-lock__title">{{ $t("linking.seatLockedTitle") }}</h2>
      <p class="seat-lock__message">
        {{ lock.holderName
          ? $t("linking.seatLockedMessage", { device: lock.holderName })
          : $t("linking.seatLockedMessageGeneric") }}
      </p>
      <p class="seat-lock__hint">{{ $t("linking.seatLockedPremiumHint") }}</p>
      <button type="button" class="seat-lock__sign-out" :disabled="busy" @click="signOutHere">
        {{ $t("linking.seatLockedSignOut") }}
      </button>
    </div>
  </div>
</template>

<script>
// Shown over the app when this browser is signed into a free account that
// another device holds (authStore claimSeat) — iOS DeviceSeatLockedView.
// Premium, bought in the app, unlocks every device at once; otherwise the
// reader signs out here.
import { authState, signOut } from "../stores/authStore";
import { seatHolderIconName } from "../utils/deviceIcon";
import SfIcon from "./SfIcon.vue";

export default {
  name: "SeatLockOverlay",
  components: { SfIcon },
  data() {
    return { busy: false };
  },
  computed: {
    lock() {
      const lock = authState.seatLock;
      const uid = authState.currentUser && authState.currentUser.uid;
      return lock && authState.isAuthenticated && lock.uid === uid ? lock : null;
    },
    holderIcon() {
      return seatHolderIconName(this.lock && this.lock.holderKind);
    },
  },
  methods: {
    async signOutHere() {
      if (this.busy) return;
      this.busy = true;
      try {
        await signOut();
        this.$router.replace("/signin");
      } finally {
        this.busy = false;
      }
    },
  },
};
</script>

<style scoped>
.seat-lock {
  position: fixed;
  inset: 0;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px 16px;
  background: var(--app-bg, #fff);
  color: var(--app-text, #111);
}

.seat-lock__card {
  width: 100%;
  max-width: 440px;
  text-align: center;
}

.seat-lock__device {
  width: 96px;
  height: 96px;
  margin: 0 auto 22px;
  border-radius: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #007aff;
  color: #ffffff;
}

.seat-lock__title {
  margin: 0 0 12px;
  font-size: 24px;
  font-weight: 700;
}

.seat-lock__message,
.seat-lock__hint {
  margin: 0 0 12px;
  font-size: 16px;
  line-height: 1.45;
  opacity: 0.75;
}

.seat-lock__sign-out {
  margin-top: 20px;
  padding: 12px 20px;
  border: 0;
  border-radius: 14px;
  background: transparent;
  color: #e5484d;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
}

.seat-lock__sign-out:disabled {
  opacity: 0.5;
  cursor: default;
}
</style>
